import { render, staticRenderFns } from "./DoorColorCost.vue?vue&type=template&id=31c861c6&"
import script from "./DoorColorCost.vue?vue&type=script&lang=js&"
export * from "./DoorColorCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports